import { render, staticRenderFns } from "./referrals-table.vue?vue&type=template&id=ecc693ae"
import script from "./referrals-table.vue?vue&type=script&lang=js"
export * from "./referrals-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports